import React from 'react';
import get from 'lodash/get';
import differenceBy from 'lodash/differenceBy';
import Button from '@atlaskit/button';
import { ProductCatalogueItem } from '@atlassian/cssxp-types-product';
import { Divider } from '@css-xp/base/divider';
import { EntitlementIcon, useFeatureToggle } from '@css-xp/base';
import { JIRA_PRODUCT_DISCOVERY_PRODUCT_ID, JIRA_PRODUCT_IDS, STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';
import { usePartnerCatalogueContext } from './context/partner-catalogue-context';
import { usePartnerProductCatalogueContext } from './products-in-catalogue';
import './jira-recommendations.scss';

export const jiraProductIds = Object.values(JIRA_PRODUCT_IDS).map((id) => ({ id }));

type JiraRecommendationsProps = {
  existingJiraProductIds: { id: string }[];
};

export const JiraRecommendations: React.FC<JiraRecommendationsProps> = ({ existingJiraProductIds }) => {
  const { quoteItems, setCatalogueItem } = usePartnerCatalogueContext();
  const { data: catalogueData } = usePartnerProductCatalogueContext();
  const alreadyFetchedProducts = catalogueData ? catalogueData?.nativeCatalog?.nodes : [];
  const { existingCloudSiteProductIds } = usePartnerProductCatalogueContext();
  const [isEnabled] = useFeatureToggle();
  const isJPDAsJiraFamilyEnabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_JPD_AS_JIRA_FAMILY);

  const jiraIds = jiraProductIds?.filter((item) => item.id !== JIRA_PRODUCT_IDS.JWM);

  if (isJPDAsJiraFamilyEnabled) {
    jiraIds.push({
      id: JIRA_PRODUCT_DISCOVERY_PRODUCT_ID,
    });
  }

  const recommendedItems = differenceBy(jiraIds, [...quoteItems, ...existingJiraProductIds], 'id')
    ?.filter((product) => !existingCloudSiteProductIds?.includes(product?.id))
    .map((product) => ({
      ...product,
      ...alreadyFetchedProducts?.find((catalogueProduct: any) => catalogueProduct.id === product.id),
    }));

  return recommendedItems?.length > 0 ? (
    <div className="jira-recommendation-block">
      <Divider className="jira-recommendation-divider" />
      {recommendedItems.length > 0 && <h4 className="add-recommended-products-header">Add other Jira product(s)?</h4>}

      <div className="jira-recommended-products">
        {recommendedItems.map((product: ProductCatalogueItem) => (
          <div key={product?.id} className="jira-recommendation-name" data-testid="jira-recommendation-name">
            <span>
              <EntitlementIcon productId={get(product, 'id')} className="avatar medium" isCloud />{' '}
              <label>{get(product, 'name')}</label>
            </span>
            <Button
              testId="add-recommended-jira-product"
              onClick={() =>
                setCatalogueItem({
                  ...alreadyFetchedProducts?.find((catalogueProduct: any) => catalogueProduct.id === product.id),
                })
              }
            >
              Add
            </Button>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};
